export const DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP = "DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP";
export const DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP_RESPONSE = "DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP_RESPONSE";
export const DASHBOARD_PANEL_GADGET_CHART_DATA = "DASHBOARD_PANEL_GADGET_CHART_DATA";
export const DASHBOARD_PANEL_GADGET_CHART_DATA_RESPONSE = "DASHBOARD_PANEL_GADGET_CHART_DATA_RESPONSE";

export const DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST = "DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST";
export const DASHBOARD_PANEL_SEARCH_DEVELOPERS_RESULT = "DASHBOARD_PANEL_SEARCH_DEVELOPERS_RESULT";